import * as React from 'react'
import { Typography, Paper, Box, Button, makeStyles } from '@material-ui/core'
import { getClientProfiles, getTheInitialInterview, saveTheInitialInterview, listCourse, listCoach, ClientAPI } from '../../utils/api';
import { useParams } from 'react-router';
import { useFeedback } from '../../components/Feedback';
import { DefaultClientProfiles, TheInitialInterviewSuggestionType } from '../../constants';
import ClientProfilesView from '../../components/ClientProfilesView';
import CoachingQuestionnaireSurvey, { DataProps } from '../../components/CoachingQuestionnaireSurvey';
import PurpleFront from '../../assets/purple_front.png';
import InitialInterviewPreview from '../../components/InitialInterviewPreview';
import { useQuery } from 'react-query';
import { support107 } from '../../utils';
const useStyles = makeStyles({
    titleBox: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    editor: {
        height: '500px'
    }
})

const ClientHome = () => {

    const { showToast, showLoading, hideLoading } = useFeedback()
    const { data: oneOnOneCoaches } = useQuery<any>('one_on_one_coaching', listCoach)
    const [coach, setCoach] = React.useState({
        user_id: 0,
        name: ''
    })

    const classes = useStyles()
    const params: { id: string, clientId: string } = useParams()
    const {data: clientVersion} = useQuery<any>(['clientVersion',params.clientId], ()=> ClientAPI.getVersion(params.clientId))

    const [profiles, setProfiles] = React.useState<ClientProfiles>(DefaultClientProfiles)
    const [courses, setCourses] = React.useState<Course[]>([])
    const [coachingQuestionnaireSurveyData, setCoachingQuestionnaireSurveyData] = React.useState<DataProps>({
        input: {},
        radio: {},
        checkbox: {},
        familyMember: [],
        suggestion: {}
    })

    const loadData = () => {
        let p: ClientProfiles;

        getClientProfiles(params.clientId).then(res => {
            setProfiles(res.data)
            p = res.data;
            listCourse('online').then(res => {
                setCourses(res)
            })

            return getTheInitialInterview(params.id)
        }).then(res => {
            let surveyData: DataProps
            setCoach({
                user_id: res.data.id,
                name: res.data.coachName,
            })
            if (res.data.survey) {
                surveyData = JSON.parse(res.data.survey);
            } else {
                surveyData = coachingQuestionnaireSurveyData;
            }
            if (p) {
                if (!surveyData.input['name']) {
                    surveyData.input['name'] = p.name
                }
                if (!surveyData.input['gender']) {
                    surveyData.input['gender'] = p.gender
                }
                if (!surveyData.input['age']) {
                    surveyData.input['age'] = p.age
                }
                if (!surveyData.radio['maritalStatus']) {
                    if (['单身', '已婚', '已婚分居', '离异'].indexOf(p.marital_status) >= 0) {
                        surveyData.radio['maritalStatus'] = ['单身', '已婚', '已婚分居', '离异'].indexOf(p.marital_status) + ''
                    }
                }
                if (surveyData.familyMember.length < 1 && p.children) {
                    const children = JSON.parse(p.children);
                    surveyData.input['familyMemberCount'] = children.length
                    for (let child of children) {
                        surveyData.familyMember.push(
                            {
                                relationship: child['gender'],
                                age: child['age']
                            }
                        )
                    }
                }
                if (!surveyData.suggestion) {
                    surveyData.suggestion = {}
                }
            }
            setCoachingQuestionnaireSurveyData({ ...surveyData });
        })
    }

    const handleSaveCoaching = (submit: boolean) => () => {
        const surveyData = JSON.stringify(coachingQuestionnaireSurveyData)
        if (submit) {
            console.error(coachingQuestionnaireSurveyData.suggestion)
            console.error(Object.keys(coachingQuestionnaireSurveyData.suggestion).length)
            if ((!coachingQuestionnaireSurveyData.suggestion || Object.keys(coachingQuestionnaireSurveyData.suggestion).length < 1) && !coachingQuestionnaireSurveyData.input.other_suggestion) {
                showToast('请选择教练建议或填写其他建议')
                return;
            }
            const oneSuggesstion = coachingQuestionnaireSurveyData.suggestion[TheInitialInterviewSuggestionType.one_on_one_coaching]
            const courseSuggesstion = coachingQuestionnaireSurveyData.suggestion[TheInitialInterviewSuggestionType.free_course]
            const groupSuggesstion = coachingQuestionnaireSurveyData.suggestion[TheInitialInterviewSuggestionType.group_coaching]
            if (oneSuggesstion && !oneSuggesstion.type) {
                showToast('请选择一对一教练类型')
                return;
            }
            if(!support107(clientVersion?.version) && oneSuggesstion && (!oneSuggesstion.coachId || oneSuggesstion.coachId === '0')) {
                showToast('请选择一对一的教练')
                return;

            }
            
            if(!support107(clientVersion?.version) && oneSuggesstion && !oneSuggesstion.numberOfTimes) {
                showToast('请输入一对一教练次数')
                return;

            }
            if (groupSuggesstion && !groupSuggesstion.type) {
                showToast('请选择团体教练类型')
                return;
            }

            // if(!support107(clientVersion?.version) && groupSuggesstion && groupSuggesstion.type === 'group' && !groupSuggesstion.groupCoachingLevel){
            //     showToast('请选择团体教练阶段')
            //     return;
            // }

            if (courseSuggesstion && (!courseSuggesstion.newCourses || courseSuggesstion.newCourses.length < 1)) {
                showToast('请选择推荐的线上免费课程')
                return;
            }
        }

        showLoading('提交中...')
        saveTheInitialInterview(params.id, params.clientId, surveyData, submit ? 1 : 0).then(res => {
            showToast('提交成功')
            hideLoading()
        }).catch(e => {
            showToast('提交失败')
            hideLoading()
        })
    }

    const handleDataChange = (data: DataProps) => {
        setCoachingQuestionnaireSurveyData(data)
    }

    React.useEffect(() => {
        loadData()
    }, [])

    return <div>
        <ClientProfilesView profiles={profiles} />

        <Paper style={{ padding: '16px', boxSizing: 'border-box', display: 'flex', marginTop: '20px' }}>
            <Box flexGrow={1} pr={2}>
                <div className={classes.titleBox} style={{ marginBottom: '20px' }}>
                    <Typography >根基家庭支持中心</Typography>
                    <Button onClick={handleSaveCoaching(false)}>保存来访者信息</Button>
                </div>
                <Box style={{ height: '720px', overflow: 'auto' }}>
                    <CoachingQuestionnaireSurvey version={clientVersion?.version} writer={coach} coaches={oneOnOneCoaches ? oneOnOneCoaches : []} isVip={profiles.isVip} courses={courses} data={coachingQuestionnaireSurveyData} onDataChange={handleDataChange} />
                    <Box display="flex" justifyContent="center" p={2}><Button onClick={handleSaveCoaching(true)} >发送建议</Button></Box>
                </Box>
                <Box style={{ boxShadow: '0 -2px 5px rgba(0,0,0,.5)', height: '1px' }}></Box>
            </Box>
            <Box flexShrink={0} style={{ position: 'relative', borderLeft: '1px solid #e1e1e1', padding: '0 0 0 16px', boxSizing: 'border-box', overflow: 'auto' }}>
                <Box width="375px">
                    <InitialInterviewPreview coaches={oneOnOneCoaches} isVip={profiles.isVip} otherSuggestion={coachingQuestionnaireSurveyData.input['other_suggestion']} coachName={coach.name} suggestions={coachingQuestionnaireSurveyData.suggestion} />
                </Box>
                <img style={{ width: '375px', position: 'absolute', top: 0, pointerEvents: 'none' }} src={PurpleFront} />
            </Box>
        </Paper>
    </div>
}

export default ClientHome